exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PanelWrapper-titleText-V5e6d {\n    margin: 0px;\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.PanelWrapper-panelBorder-gLPbB {\n    border-radius: 8px;\n    border: 1px solid var(--border-color);\n    padding: 22px 25px;\n    margin-bottom: 100px;\n}\n\n@media screen and (max-width: 767px) {\n    .PanelWrapper-panelBorder-gLPbB {\n        margin-bottom: 0px;\n    }\n}\n.PanelWrapper-tabItem-LdWWv:hover {\n    color: var(--btn-primary-bg);\n}", ""]);

// exports
exports.locals = {
	"titleText": "PanelWrapper-titleText-V5e6d",
	"panelBorder": "PanelWrapper-panelBorder-gLPbB",
	"tabItem": "PanelWrapper-tabItem-LdWWv"
};